import {
  calcYourDistricts,
  findSlide,
  isAdjacent,
  isSelected,
  isValidAnswer,
  nextToOrBelow,
  setId,
  trackAction
} from '../utils';

const slides = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_SQUARE':
      // check if the clicked square is affiliated with a party
      if(!action.square.party) return state;
      if(isSelected(state.activeSlide.game_info.answers, action.square)) return state;

      let district;
      const districts = state.activeSlide.game_info.answers.reduce((prev, next) => {
        if (next.district in prev) {
          prev[next.district] = [...prev[next.district], next];
        }
        else {
          prev[next.district] = [next];
        }

        if(prev[next.district].length < state.activeSlide.game_info.num_squares){
          prev.active = next.district
        }
        return prev;
      }, {});

      const activeDistrict = districts[districts.active];

      // check if the clicked square is adjacent to the active district
      if(!isAdjacent(
          action.square,
          state.activeSlide.game_info.squares,
          activeDistrict,
          state.activeSlide.game_info.num_squares
        )) return state;

      // update the clicked square's state
      const squares = state.activeSlide.game_info.squares.map(item => {
        let selected;
        if(item.id === action.square.id || item.id === action.square.owns){
          selected = true;
        }
        return Object.assign({}, item, {
          selected
        });
      }).map(item => {
        if(!item.selected || item.district) return item;

        const length = state.activeSlide.game_info.answers.length;
        const num_squares = state.activeSlide.game_info.num_squares;

        if(length < (num_squares * 3)) district = 3;
        if(length < (num_squares * 2)) district = 2;
        if(length < num_squares) district = 1;

        return Object.assign({}, item, {
          district
        })
      });

      let answers;
      const answer = {
        ...action.square,
        district
      };

      if(state.activeSlide.game_info.answers){
        answers = [...state.activeSlide.game_info.answers, answer]
      } else {
        answers = [answer]
      }

      const yourDistricts = calcYourDistricts(answers);

      return Object.assign({}, state, {
        ...state,
        activeSlide: {
          ...state.activeSlide,
          game_info: {
            ...state.activeSlide.game_info,
            yourDistricts,
            answers,
            squares
          }
        }
      });

    case 'ADD_SQUARE_PREVIEW':
      if(!action.square.party) return state;
      if(isSelected(state.activeSlide.game_info.answers, action.square)) {
        return state;
      } else {
        const districts = state.activeSlide.game_info.answers.reduce((prev, next) => {
          if (next.district in prev) {
            prev[next.district] = [...prev[next.district], next];
          }
          else {
            prev[next.district] = [next];
          }

          if(prev[next.district].length < state.activeSlide.game_info.num_squares){
            prev.active = next.district
          }
          return prev;
        }, {});

        const activeDistrict = districts[districts.active];
        let previewable = true;

        // check if the clicked square is adjacent to the active district
        if(!isAdjacent(
          action.square,
          state.activeSlide.game_info.squares,
          activeDistrict,
          state.activeSlide.game_info.num_squares
        )) {
          previewable = false;
        }

        const squares = state.activeSlide.game_info.squares.map(item => {
          let district;
          let preview;
          const length = state.activeSlide.game_info.answers.length;
          const num_squares = state.activeSlide.game_info.num_squares;

          if(length < (num_squares * 3)) district = 3;
          if(length < (num_squares * 2)) district = 2;
          if(length < num_squares) district = 1;


          if(item.id === action.square.id || item.id === action.square.owns){
            preview = `preview-district-${district}`;

            if(!previewable){
              preview = 'preview-error';
            }
          }

          return Object.assign({}, item, {
            preview
          });
        });

        return Object.assign({}, state, {
          ...state,
          activeSlide: {
            ...state.activeSlide,
            game_info: {
              ...state.activeSlide.game_info,
              squares
            }
          }
        });
      }

    case 'REMOVE_SQUARE_PREVIEW':
      if(action.id){
        const squares = state.activeSlide.game_info.squares.map(item => {
          let preview;

          if(item.id === action.id){
            preview = null;
          }
          return Object.assign({}, item, {
            preview
          });
        });

        return Object.assign({}, state, {
          ...state,
          activeSlide: {
            ...state.activeSlide,
            game_info: {
              ...state.activeSlide.game_info,
              squares
            }
          }
        });
      }

    case 'GOTO_SLIDE':
      return Object.assign({}, state, {
        activeSlide: findSlide(state.allSlides, setId(action.id, state))
      });
    default:
      return state;
  }
}

export default slides;



// WEBPACK FOOTER //
// ./src/reducers/slides.js